export const TURN_STATUS = {
  CANCELED: 'canceled',
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ABSENT: 'absent',
  ASSIGNED: 'assigned'
};
